export const NEW_CLOUD_SITE = 'NEW SITE';
export const NEW_CLOUD_SITE_ID = 'new-site';

export const CART_ROUTE_PARAMS = {
  CUSTOMER: 'customer',
  BILLING_PROFILE: 'billingProfile',
};

export const CART_COLUMNS_CONSTANTS = {
  SELECT: 'Select',
  PRODUCT: 'Product',
  SUBSCRIPTION: 'Subscription',
  PLAN: 'Plan',
  CUSTOMER_CONTACT: 'Customer contact',
  LIST_PRICE: 'List price',
  PARTNER_DISCOUNT: 'Partner discount',
  OTHER_DISCOUNT: 'Other discounts',
  NEXT_BILL_DATE: 'Next bill date',
  QUANTITY: 'Quantity',
  BILLING_CYCLE: 'Billing cycle',
  STATUS: 'Status',
  TOTAL: 'Total',
  TAX_ESTIMATE: 'Tax estimate',
};

export const QUOTE_CART_COLUMNS_CONSTANTS = {
  SELECT: 'Select',
  PRODUCT: 'Product',
  SUBSCRIPTION: 'Subscription',
  PLAN: 'Plan',
  BILLING_CYCLE: 'Billing cycle',
  QUANTITY: 'Quantity',
  START_DATE: 'Start date',
  END_DATE: 'Renewal/End date',
  LIST_PRICE: 'List price',
  OTHER_DISCOUNT: 'Other discounts',
  CREDITS: 'Credits',
  PARTNER_DISCOUNT: 'Partner discount',
  TAX_ESTIMATE: 'Tax estimate',
  NET_PRICE: 'Net Price',
  STATUS: 'Status',
};
